import { render, staticRenderFns } from "./rate_plan.vue?vue&type=template&id=60aba44e&scoped=true&"
import script from "./rate_plan.vue?vue&type=script&lang=js&"
export * from "./rate_plan.vue?vue&type=script&lang=js&"
import style0 from "./rate_plan.vue?vue&type=style&index=0&id=60aba44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aba44e",
  null
  
)

export default component.exports